import React from 'react'

import { HighLights, HighLightsVideo, PrimaryButton } from '../../components'
import { HeadScreenshot, HeadScreenshotIcon, StarIcon } from '../../screenshots'
import { scrollToTariffs } from '../../utils'

const MarketplaceBadge = ({ color, children }) => (
  <div className="flex items-center bg-[#1A2836] rounded-[24px] px-6 py-4">
    <div className="relative mr-3 w-4 h-4 flex items-center justify-center">
      <span
        className="absolute inset-0 rounded-full opacity-90 blur-[8px] z-0"
        style={{ backgroundColor: color }}
      />
      <span
        className="w-3 h-3 rounded-full block relative z-10"
        style={{ backgroundColor: color }}
      />
    </div>
    <span className="text-white font-bold uppercase text-[16px] tracking-wide">
      {children}
    </span>
  </div>
)

const RepricerHero = ({ title, subtitle, description, minimal = false }) => (
  <section className={minimal ? 'relative overflow-hidden' : ''}>
    {minimal ?
      <HighLightsVideo />
    : <HighLights />}
    <div
      className={`mx-5 lg:mx-0 mt-10 lg:mt-[50px] flex flex-col lg:items-center z-20 ${
        minimal ? 'relative pb-16 lg:pb-[74px]' : ''
      }`}
    >
      <span className="flex items-start text-[36px] leading-[40px] lg:text-[70px] lg:leading-[100px] text-[#E0FF46] font-medium -tracking-[2px] lg:-tracking-[3px]">
        {title}
        <span className="lg:mt-5">
          <StarIcon />
        </span>
      </span>
      <span className="block text-[36px] leading-[40px] lg:text-[70px] lg:leading-[70px] text-[#DDDDDE] font-medium -tracking-[2px] lg:-tracking-[3px]">
        {subtitle}
      </span>
      <div
        className={`mt-6 flex flex-col lg:items-center ${
          minimal ? 'lg:mt-10' : 'mb-10 lg:my-10'
        }`}
      >
        {description.map((line, index) => (
          <span
            key={line}
            className={`block text-[#DDDDDE] font-medium text-[16px] leading-[24px] lg:text-[24px] lg:leading-[34px] ${
              !minimal && index === description.length - 1 ? 'mb-3' : ''
            }`}
          >
            {line}
          </span>
        ))}
        {!minimal && (
          <div className="flex flex-wrap gap-2">
            <MarketplaceBadge color="#B531A4">Wildberries</MarketplaceBadge>
            <MarketplaceBadge color="#1C77FF">Ozon</MarketplaceBadge>
            <MarketplaceBadge color="#EFCE56">Yandex Market</MarketplaceBadge>
          </div>
        )}
      </div>
      {!minimal && (
        <div className="flex justify-center items-center flex-col lg:flex-row">
          <PrimaryButton
            className="w-full py-5 lg:w-fit lg:px-12 lg:py-6 flex items-center justify-center"
            onClick={() =>
              (window.location.href = 'https://go.priceninja.ru/products')
            }
          >
            <span className="text-white font-semibold text-[18px] leading-[21px] lg:text-xl lg:leading-6">
              Попробовать бесплатно
            </span>
          </PrimaryButton>
          <PrimaryButton
            className="w-full py-5 lg:w-fit lg:px-12 lg:py-6 flex lg:hidden items-center justify-center !bg-[#1A2836] mt-3 !hover:bg-[#1A2836]"
            onClick={event => {
              event.preventDefault()
              scrollToTariffs()
            }}
          >
            <span className="text-white font-semibold text-[18px] leading-[21px] lg:text-xl lg:leading-6">
              Тарифы
            </span>
          </PrimaryButton>
        </div>
      )}
    </div>
    {!minimal && (
      <div className="flex items-center mt-10 lg:mt-[109px] relative">
        <div className="mx-auto z-20 overflow-hidden lg:relative w-full lg:w-auto">
          <div className="hidden lg:block">
            <HeadScreenshot />
          </div>
          <div className="lg:hidden relative">
            <HeadScreenshotIcon width="100%" height="auto" />
          </div>
          <div className="absolute w-full px-5 lg:px-0 bottom-5 lg:bottom-10 flex items-center justify-center h-fit left-1/2 transform -translate-x-1/2">
            <a
              href="https://rutube.ru/video/a77fb367c6e9625b1c51236b4d424f66"
              className="w-full lg:w-fit"
              target="_blank"
              rel="noreferrer"
            >
              <PrimaryButton className="w-full px-8 py-4 lg:w-auto lg:py-8 lg:px-16 bg-[#1A2937A6] rounded-full backdrop-blur-[10px]">
                <span className="block text-white text-[20px] leading-[21px] lg:text-[40px] lg:leading-[48px] font-medium tracking-tight">
                  Видео о сервисе
                </span>
              </PrimaryButton>
            </a>
          </div>
        </div>
      </div>
    )}
  </section>
)

export { RepricerHero }
